export const DEFAULT_CSV_SEPARATOR = ',';
